import { http, httpFile } from './http_service';


//Get List for table view with - Pagination for Admin
export function listPage(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedBDM:obj.selectedBDM,
        selectedStatus:obj.selectedStatus,
        referralPartnerId:obj.referralPartnerId,
        fromDate:obj.fromDate,
        toDate:obj.toDate,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field,
    }
    return http().get(`/leads/list-page`, {
        params:params
    });
}

//For Export Leads List
export function createLeadsListExport(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedStatus:obj.selectedStatus,
        referralPartnerId:obj.referralPartnerId,
        fromDate:obj.fromDate,
        toDate:obj.toDate,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field,
    }
    return http().get(`/leads/export/create-leads-list`, {
        params:params
    });
}

// Delete Export Leads List in temp folder
export function deleteTempLeadsListExport(data){
    return http().put(`/leads/export/delete-temp-leads-list`, data)
}

//Get List for table view with - Pagination for dealer
export function listPageDealer(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedBDM:obj.selectedBDM,
        selectedStatus:obj.selectedStatus,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field,
        leadSource:obj.leadSource,
    }
    return http().get(`/leads/dealer/list-page`, {
        params:params
    });
}


//Get List for table view with - Pagination for bdm
export function listPageBDM(obj){
  let params = {
      page:obj.page,
      recordsPerPage:obj.recordsPerPage,
      q:obj.q,
      selectedBDM:obj.selectedBDM,
      selectedStatus:obj.selectedStatus,
      sort_direction:obj.sort_direction,
      sort_field:obj.sort_field
  }
  return http().get(`/leads/bdm/list-page`, {
      params:params
  });
}

// Get Single leads
export function single(id){
    return http().get(`/leads/${id}`);
}

/**
 * Add Vehicle information for leads
 * @param integer quoteId
 * @param object data
 * @returns
 */
export function add(data){
    return http().post('/leads/add', data)
}
/**
 * Update Vehicle information
 * @param integer quoteId
 * @param object data
 * @returns
 */
export function update(quoteId, data){
    return http().put(`/leads/update/${quoteId}`, data)
}

/**
 * Submit Vehicle information
 * @param integer quoteId
 * @param object data
 * @returns
 */
export function submit(quoteId, data){
    return http().put(`/leads/submit/${quoteId}`, data)
}

/**
 * Get Leads Notes
 */
 export function getLeadsNote(quoteId){
    return http().get(`/leads/get-leads-note/${quoteId}`)
}

/**
 * Add Leads Notes
 */
export function addLeadsNote(data){
    return http().post('/leads/add-leads-note', data)
}

/**
 * Update Leads Notes
 */
 export function updateLeadsNote(quoteId, data){
    return http().post(`/leads/update-leads-note/${quoteId}`, data)
}

/**
 * Convert Leads into Quote
 * @param integer quoteId
 */
 export function convertLeads(quoteId){
    return http().get(`/leads/convert-leads/${quoteId}`)
}

/**
 * Delete documents
 * @param {*} id
 * @returns
 */
export function documentRemove(id){
    return http().post(`/leads-document/remove/${id}`);
}

/**
 * Document Add Or Update AliasName
 * @param {*} id
 * @param {*} data
 * @returns
 */
export function documentAddOrUpdateAliasName(id, data){
    return http().put(`/leads-document/document-add-or-update-alias-name/${id}`, data);
}

/**
 * Delete Leads
 * @param integer quoteId
 */
export function deleteLeads(quoteId){
    return http().get(`/leads/delete-leads/${quoteId}`)
}

/**
 * Update followup date on Leads
 * @param integer quoteId
 */
export function updateFollowupDate(quoteId, data){
    return http().put(`/leads/update-followup-date/${quoteId}`, data)
}

/**
 * Update leads status
 * @param integer quoteId
 */
export function updateLeadsStatus(quoteId, data){
    return http().put(`/leads/update-leads-status/${quoteId}`, data)
}

/**
 * Leads transfer to different user
 * @param {Integer} leadsId
 * @param {object} data
 * @returns
 */
export function transferDealer(leadsId, data){
  return http().put(`/leads/dealer/transfer/${leadsId}`, data)
}













